export const parrafos = [
  "Somos una empresa dedicada al desarrollo de soluciones basadas en software. Acompañamos y potenciamos a nuestros clientes, aportando la visión tecnológica para la transformación y el crecimiento.",
  "Trabajamos adoptando los principios del manifiesto ágil adaptando la metodología particular de cada proyecto a sus características y las necesidades del cliente.",
  "Somos flexibles con el foco puesto en las necesidades reales de nuestros clientes y trabajamos en un marco metodológico producto de años de experiencia.",
];
